import { defineMessages } from "react-intl";
import { BaseObjLabels } from "../base-obj";

/**
 * Localized labels for OrganizationGroup fields
 */
export const OrganizationGroupLabels = {
  ...BaseObjLabels,
  // Add AuthorEditorFields if needed
  ...defineMessages({
    // organizationId <- not used, ignoring
    name: {
      defaultMessage: "name",
      description:
        "Field label for organization group name (OrganizationGroup.name)"
    },
    type: {
      defaultMessage: "type",
      description:
        "Field label for organization group type (OrganizationGroup.type)"
    },
    description: {
      defaultMessage: "description",
      description:
        "Field label for organization group description (OrganizationGroup.description)"
    },
    entitlements: {
      defaultMessage: "entitlements",
      description:
        "Field label for organization group entitlements (OrganizationGroup.entitlements)"
    }
  })
};

export const OrganizationGroupValues = {
  name: defineMessages({
    undefined: {
      defaultMessage: "Unknown",
      description:
        "Fallback value for missing organization group name (OrganizationGroup.name undefined)"
    }
  })
};
